import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { socket } from 'api';
import { deactivateAllEvents } from 'store/actions/events';
import { Signal, GridBox, Grid, TableHead, TableHeadRow, TableHeaders, SubmitAllPlace, SubmitAll, Error } from 'libs/ui';
import { demoData } from './signals-grid.mocks';

const test = false;
const waitTimeout = 10000;
let timerId;

export const SignalsGrid = (props) => {
  const { t } = useTranslation();
  const signals = test ? demoData : props.signals;
  const [errorMessage, setErrorMessage] = useState(null);
  const [disabled, setDisabled] = useState(false);

  /**
   * socket answers
   */
  useEffect(() => {
    socket.on('get_active_events', onAnswer);
    socket.on('error', onError);

    return () => {
      socket.off('get_active_events', onAnswer);
      socket.off('error', onError);
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, []);

  /**
   * on answer
   * @param {*} msg
   */
  const onAnswer = (__msg) => {
    deactivateAllEvents();
    setDisabled(false);
    setErrorMessage(null);

    if (timerId) {
      clearTimeout(timerId);
    }
  };

  /**
   * on error
   * @param {*} msg
   */
  const onError = (msg) => {
    if (timerId) {
      clearTimeout(timerId);
    }
    setDisabled(false);
    setErrorMessage('Ошибка: ' + msg);
  };

  /**
   * confirm all events
   */
  const confirm = () => {
    setDisabled(true);

    timerId = setTimeout(() => {
      setDisabled(false);
      setErrorMessage(t('messages.Ошибка подтверждения событий: превышено время ожидания ответа'));
    }, waitTimeout);

    socket.call('confirm_event_all', {});
  };

  /**
   * get elements
   * @returns
   */
  const getSignalsList = () => {
    let signalsList = [];
    if (signals) {
      signalsList = signals.map((item, key) => {
        return <Signal view="full2" key={key} {...item} />;
      });
    }

    return signalsList;
  };

  const signalsList = getSignalsList();
  const rightConfirm = window.haveRight('mnemo.confirm_events');

  return (
    <GridBox className={disabled ? 'loading' : ''}>
      {rightConfirm && !!signals && signals.length > 0 && (
        <SubmitAllPlace>
          <SubmitAll onClick={confirm}>{t('buttons.Подтвердить все')}</SubmitAll>
        </SubmitAllPlace>
      )}

      {errorMessage && <Error>{errorMessage}</Error>}

      <Grid>
        <TableHead>
          <TableHeadRow>
            <TableHeaders width="190">{t('windows.Начало сигнала')}</TableHeaders>
            <TableHeaders width="180">{t('windows.Источник')}</TableHeaders>
            <TableHeaders>{t('windows.Описание сигнала')}</TableHeaders>
            <TableHeaders width="160" align="right">
              {t('windows.Действия')}
            </TableHeaders>
          </TableHeadRow>
        </TableHead>
        <tbody>{signalsList}</tbody>
      </Grid>
    </GridBox>
  );
};
